import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './_styles_/AuctioneerDataTemplateUploadCreate.css';
import useExtendedState from '../../hooks/useExtendedState';
import useSingleValidator from '../../hooks/useSingleValidator';
import { AUCTIONEER_DATA_TEMPLATE_NAME_MAX_LETTERS, auctioneerDataTemplateNameValidator } from '../../validators/auctioneerDataTemplates';
import TextField from '../fields/TextField';
import useEffectOnLoad from '../../hooks/useEffectOnLoad';
import { compositeValidator, wafValidator } from '../../hooks/validationSupport';

AuctioneerDataTemplateUploadCreate.propTypes = {
    setExtraVariables: PropTypes.func.isRequired,
    setExtraVariablesValid: PropTypes.func.isRequired,
};

function AuctioneerDataTemplateUploadCreate(props) {
    const {
        setExtraVariables,
        setExtraVariablesValid,
    } = props;
    const { t } = useTranslation();
    const nameState = useExtendedState('');
    const initialValidity = false;
    const { validator } = useSingleValidator(initialValidity, useMemo(() => compositeValidator(auctioneerDataTemplateNameValidator(t), wafValidator(t)), [t]));
    const onNameChanged = (newName) => {
        setExtraVariables([{
            name: 'name',
            value: newName,
        }]);
    };
    const onNameValidated = (newName, isValid) => {
        setExtraVariablesValid(isValid);
    };
    useEffectOnLoad(() => setExtraVariablesValid(initialValidity));
    return (
        <div className="auctioneer-data-template--create-upload">
            <TextField
                label={t('auctioneer-data-templates.name')}
                state={nameState}
                onChange={onNameChanged}
                onValidated={onNameValidated}
                validator={validator}
                maxLength={AUCTIONEER_DATA_TEMPLATE_NAME_MAX_LETTERS}
                className="auctioneer-data-template--create-upload--name"
                placeholder={t('auctioneer-data-templates.placeholder.name')}
                useDynamicWidth={false}
                isRequired
            />
        </div>
    );
}

export default AuctioneerDataTemplateUploadCreate;
